module.exports = __webpack_public_path__ + "static/media/rs-1.249d6f88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/rs-1.jpg
// module id = 107
// module chunks = 0